<template>
  <nav class="main-menu" :class="{ 'active': $store.state.mainMenu.status }">
    <router-link :to="{ name: 'index' }" class="nav-item" exact>Naslovnica</router-link>
    <router-link :to="{ name: 'about' }" class="nav-item">O nama</router-link>
    <router-link :to="{ name: 'projects' }" class="nav-item">Projekti</router-link>
    <router-link :to="{ name: 'suprasolar' }" class="nav-item">SupraSolar</router-link>
    <router-link :to="{ name: 'services' }" class="nav-item">Usluge</router-link>
    <a
      class="nav-item"
      href="https://storm-grupa.talentlyft.com/supra-net#home"
      target="_blank"
    >Posao</a>
    <!-- <router-link :to="{ name: 'jobs' }" class="nav-item">Posao</router-link> -->
    <router-link :to="{ name: 'reference' }" class="nav-item">Reference</router-link>
    <router-link :to="{ name: 'contact' }" class="nav-item">Kontakt</router-link>
  </nav>
</template>

<script>
export default {};
</script>
